import React from 'react';
import { Button } from '@material-ui/core';
import styles from './ButtonCustom.module.scss';

function ButtonCustom({
  label,
  color,
  className,
  onClick,
  href,
}: {
  label: string;
  color: 'red' | 'green' | 'grey';
  className?: string;
  onClick?: () => void;
  href?: string;
}): JSX.Element {
  return (
    <>
      <Button
        {...(!onClick && !href && { type: 'submit' })}
        classes={{ root: `${styles.root} ${styles[color]}` }}
        className={`${styles[color]} ${className && className}`}
        onClick={onClick}
        href={href}
        variant="contained"
      >
        {label}
      </Button>
    </>
  );
}

export default ButtonCustom;
